import { Cpu } from "lucide-react";

interface LogoProps {
  className?: string;
}

const Logo = ({ className = "h-8 w-auto" }: LogoProps) => {
  // Placeholder logo using an icon - will be replaced when user uploads their logo
  return (
    <div className={`flex items-center justify-center text-primary ${className}`}>
      <Cpu className="h-full w-auto" />
    </div>
  );
};

export default Logo;
